import { render } from "./InputTag.vue?vue&type=template&id=7ebd8668&scoped=true&lang=pug"
import script from "./InputTag.vue?vue&type=script&lang=js"
export * from "./InputTag.vue?vue&type=script&lang=js"

import "./InputTag.vue?vue&type=style&index=0&id=7ebd8668&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ebd8668"]])

export default __exports__